module.exports = __webpack_public_path__ + "static/img/double-win-for-rare-as-kura-dione-warren-and-naomi-kellman-awards-by-management-today.40e0393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/double-win-for-rare-as-kura-dione-warren-and-naomi-kellman-awards-by-management-today.png
// module id = RGVF
// module chunks = 0